<div class="floating-inquiry-button d-flex justify-content-center align-items-center p-4">
  <span class="button-text">
    {{ 'inquiries.common.button.createInquiry' | transloco }}
  </span>
  <cov-icon class="icon" [iconName]="IconName.QUESTION"></cov-icon>
</div>
